import { render, staticRenderFns } from "./CardDeAberturaDeCaixa.vue?vue&type=template&id=12f8721f&"
import script from "./CardDeAberturaDeCaixa.vue?vue&type=script&lang=ts&"
export * from "./CardDeAberturaDeCaixa.vue?vue&type=script&lang=ts&"
import style0 from "./CardDeAberturaDeCaixa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VRow})
